/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Iframe_Remote_Style_Guide_Not_Found_ErrorInputs */



/**
* | output |
* | --- |
* | "Style guide with ID \"{id}\" not found" |
*
* @param {Iframe_Remote_Style_Guide_Not_Found_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_not_found_error = /** @type {((inputs: Iframe_Remote_Style_Guide_Not_Found_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Not_Found_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Guide de style avec l'ID "${i?.id}" introuvable`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Styleguide mit der ID "${i?.id}" nicht gefunden`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Guida di stile con ID "${i?.id}" non trovata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Руководство по стилю с идентификатором "${i?.id}" не найдено`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se encontró la guía de estilo con ID "${i?.id}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`未找到 ID 为“${i?.id}”的样式指南`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ID「${i?.id}」のスタイルガイドが見つかりません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आईडी "${i?.id}" वाली स्टाइल गाइड नहीं मिली`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Guia de estilo com ID "${i?.id}" não encontrado`)
	return /** @type {LocalizedString} */ (`Style guide with ID "${i?.id}" not found`)
});